export default { relationshipTypesWireToInt: relationshipTypesWireToInt };

function relationshipTypesWireToInt (wireRelationshipTypes) {
  if (
    !wireRelationshipTypes ||
    !wireRelationshipTypes.relationshipTypes ||
    !wireRelationshipTypes.relationshipTypes.option ||
    !wireRelationshipTypes.relationshipTypes.option.length
  ) {
    return [];
  }
  wireRelationshipTypes = wireRelationshipTypes.relationshipTypes.option;
  let intRelationshipTypes = [];
  for (let i = 0; i < wireRelationshipTypes.length; i++) {
    let wireRelationshipType = wireRelationshipTypes[ i ];
    /**
     * First option is just 'Select...' text, it's not needed
     */
    if (i > 0) {
      intRelationshipTypes.push(relationshipTypeWireToInt(wireRelationshipType));
    }
  }
  return intRelationshipTypes;
}

function relationshipTypeWireToInt (wireRelationshipType) {
  const { _attributes, _text } = wireRelationshipType;
  return {
    value: _attributes.value,
    editable: _attributes.selectable,
    level: _attributes.level,
    text: _text,
  };
}



// WEBPACK FOOTER //
// ./src/converter/RelationshipTypesConverter.js